import { Avatar, Typography } from "antd";
import EventDisplay from "../EventDisplay";
import { useNavigate } from "react-router-dom";

import SessionDateDisplay from "./SessionDateDisplay";
import SessionActions from "./SessionActions";
import { useSessionGuest } from "../../hooks/useSession";
import { useImageSrc } from "../../hooks/useImage";

const SessionRow = ({ sessionDetails }) => {
  const session = sessionDetails?.session;
  const attendees = sessionDetails?.attendees;
  const guest = useSessionGuest(attendees);

  const guestAvatar = useImageSrc(guest?.Avatar);

  const navigate = useNavigate();

  return !sessionDetails ? null : (
    <EventDisplay
      icon={
        <Avatar
          shape="square"
          style={{ backgroundColor: "#C4AFD7" }}
          size={75}
          src={guestAvatar}
          icon={guest?.FirstName?.substring(0, 1)}
        />
      }
      title={
        <>
          <Typography.Link
            onClick={() => {
              navigate(`${session.SessionId}`);
            }}
          >
            <Typography.Title level={4}>
              {session?.Category} Session
            </Typography.Title>
            <Typography.Text type="secondary">
              with {guest?.FirstName}
            </Typography.Text>
          </Typography.Link>
        </>
      }
      date={<SessionDateDisplay session={session} />}
      info={session?.Note}
      actions={
        <>
          <SessionActions session={session} guestUser={guest} />
        </>
      }
    />
  );
};

export default SessionRow;
